import { render, staticRenderFns } from "./PwccMinimal.vue?vue&type=template&id=761eca43&"
import script from "./PwccMinimal.vue?vue&type=script&lang=js&"
export * from "./PwccMinimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports